// view
import Base from '../containers/Base'
import find from 'lodash/find'
// containers
import UMS from './UserMaintenanceAndSupport'
import RU from './RolesAndUsers'
import Support from './Support'
import Logs from './Logs'
//import WTE from './WaysToEarn'

const states = [
  {
    key: 'view_root',
    url: '/',
    name: 'App',
    title: 'Puntos Ideas',
    component: Base,
    redirectTo: (trans: {
      router: { stateService: any }
      to: () => any
      params: (arg0: string) => any
    }) => {
      const $state = trans.router.stateService
      const toState = trans.to()
      const toParams = trans.params('to')

      if (toState.name === 'App' && !toParams.view) {
        const states = ['App.UMS']
        return find(states, state => $state.target(state).exists())
      } else return null
    },
    data: {
      permissions: {
        except: 'anonymous',
        redirectTo: {
          anonymous: {
            state: 'App',
            params: {
              view: 'login'
            }
          }
        }
      }
    }
  },
  {
    key: 'view_login',
    url: 'login',
    name: 'App.login',
    title: 'Login',
    params: {
      view: 'login'
    },
    component: Base
  },
  ...UMS,
  //...WTE
  ...RU,
  ...Support,
  ...Logs
]

export default states
